import { brand } from "@carvana/helios-styles";

const Target = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={47} height={51} fill="none">
    <path
      fill={brand.tertiary}
      d="M10.36 5.068 14.497 9l4.144-3.934a2.993 2.993 0 0 0 0-4.197A2.921 2.921 0 0 0 14.5.855 2.901 2.901 0 0 0 12.437 0c-.785 0-1.522.308-2.077.87a2.994 2.994 0 0 0 0 4.198Z"
    />
    <path
      fill={brand.tertiary}
      fillRule="evenodd"
      d="M5.4 4.583a1 1 0 0 1 .936.267l4 4a1 1 0 0 1 .293.707v3.585L24.336 26.85a3 3 0 1 1-1.414 1.414l-2.9-2.899a7 7 0 1 0 3.856-2.587 1 1 0 1 1-.498-1.937 9 9 0 1 1-4.875 3.216c.03-.04.064-.076.099-.11l-2.856-2.856a1.012 1.012 0 0 1-.086.12 12.943 12.943 0 0 0-3.033 8.347c0 7.18 5.82 13 13 13s13-5.82 13-13-5.82-13-13-13a12.945 12.945 0 0 0-6.27 1.608 1 1 0 1 1-.965-1.751 14.93 14.93 0 0 1 7.235-1.857c8.284 0 15 6.715 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-3.666 1.316-7.027 3.5-9.632a.998.998 0 0 1 .244-.21l-2.869-2.869-.037.044a18.925 18.925 0 0 0-4.838 12.667c0 10.493 8.506 19 19 19 10.493 0 19-8.507 19-19 0-10.494-8.507-19-19-19-3.911 0-7.543 1.18-10.564 3.204a1 1 0 1 1-1.113-1.661 20.907 20.907 0 0 1 11.677-3.543c11.598 0 21 9.402 21 21s-9.402 21-21 21-21-9.402-21-21a20.925 20.925 0 0 1 5.347-14c.038-.043.08-.082.123-.116l-.884-.884H5.629a1 1 0 0 1-.707-.293l-4-4a1 1 0 0 1 .39-1.656l2.526-.842.842-2.526a1 1 0 0 1 .72-.657Zm.666 2.825-.646 1.94-1.94.646 2.563 2.563H8.63V9.97L6.066 7.408Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Target;
